const getters = {
	routes: state => state.app.routes,
	sidebar: state => state.app.sidebar,
	hidebreads: state => state.app.hidebreads,
	device: state => state.app.device,
	environment: state => state.app.environment,
	mainroot: state => state.app.mainroot,
	mainheight: state => state.app.mainheight,

	uid: state => state.user.uid,
	name: state => state.user.name,
	face: state => state.user.face,
	grade: state => state.user.grade,
	role: state => state.user.role,
	message: state => state.user.message,
	alertInfo: state => state.user.alertInfo,
	weekdataId: state => state.user.weekdataId,
	permission: state => state.user.permission,
	permissionSecond: state => state.user.permissionSecond,
	permissionFunction: state => state.user.permissionFunction,
	guide: state => state.user.guide,
	welcomeToast: state => state.user.welcomeToast,

	dataanalysisComicviewTopicId: state => state.params.dataanalysisComicviewTopicId,
	dataanalysisComicviewComicId: state => state.params.dataanalysisComicviewComicId,
}
export default getters
